import {Flex, TabMenuItem, TabsMenu, TabsSkinEnum} from '@priority-software/priority-style-react';
import React, {FC, useMemo, useRef, useState} from 'react';
import {SideBar} from './SideBar';
import {RichText} from './RichText';
import styles from './styles.module.scss';
import {useEmailContext} from '../context';
import {getLanguageTabs} from '../../Automations/components/RuleDialog/parts/AutomationActionToolbar/utils';
import {ETargetAutoFill} from './RichText/types';
import {createDataTestId} from '../../../utils/dataTestId';

export const BodyEmailEditor: FC = () => {
    const {
        states,
        handlers: {updateLanguage, updateEmailHTML}
    } = useEmailContext();

    const [activeTab, setActiveTab] = useState(states.language);

    const languageTabs = useMemo(getLanguageTabs, []);

    const tabs = useMemo(
        () =>
            languageTabs.map(tab => (
                <TabMenuItem
                    {...createDataTestId(`email-tab-${tab.lang}`, true)}
                    key={tab.id}
                    onTabClick={async () => {
                        if (activeTab === tab.id) return;
                        await updateEmailHTML();
                        setActiveTab(tab.id);
                        updateLanguage(tab.id);
                    }}
                    isActive={activeTab === tab.id}
                    text={tab.title}
                    id={tab.id}
                />
            )),
        [activeTab, states.emailEditor]
    );

    const targetAutoFill = useRef(ETargetAutoFill.EDITOR);
    const subjectInputRef = useRef<HTMLInputElement>(null);

    const messageCursorLastPosition = useRef<number>(
        states[states.language]?.editorSubject?.length || ''
    );

    const props = {
        messageCursorLastPosition,
        subjectInputRef,
        targetAutoFill
    };

    return (
        <Flex direction="column" componentClasses={styles.containerGap}>
            <TabsMenu skin={TabsSkinEnum.folder}>{tabs}</TabsMenu>
            <Flex componentClasses={styles.containerGap}>
                <SideBar {...props} />
                <RichText {...props} />
            </Flex>
        </Flex>
    );
};
